import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { combineLatest, map, Observable, of, tap } from 'rxjs';

import { NavigationService } from '../../../navigation/service/navigation.service';
import { EstimateConsultationService } from '../../../online-estimate/service/estimate-consultation.service';
import { PatientService } from '../service/patient.service';

@Injectable()
export class PatientFormGuard {
  constructor(
    private readonly patientService: PatientService,
    private readonly navigationService: NavigationService,
    private readonly estimateConsultationService: EstimateConsultationService,
  ) {}

  isVerificationProcess =
    this.estimateConsultationService.getIsVerificationProcess();

  canActivate(): Observable<boolean> {
    if (!localStorage.getItem('token')) return of(false);

    return combineLatest([this.patientService.isPatient()]).pipe(
      tap(([isPatient]) => {
        if (isPatient && !this.isVerificationProcess) {
          this.navigationService.navigateToHomePage();
        }
      }),
      map(([isPatient]) => !isPatient || this.isVerificationProcess),
    );
  }
}

export const canActivate: CanActivateFn = () =>
  inject(PatientFormGuard).canActivate();
